import * as React from "react";
import { getBexApiContext } from "bernie-context";
import { ContextInput } from "@shared-ui/lodging-reviews/dist/commonjs/__generated__/globalTypes";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

export interface PropertyBexApiComponentProps {
  inputs: {
    context?: ContextInput;
    propertyId: string;
  };
}

/**
 * Used to wrap Shared UI or Bex API components relevant to Properties.
 *
 * See PropertyReviewsWrapper or PropertyReviewsHeadline for example.
 * @param Component
 * @constructor
 */
export const PropertyBexApiWrapper = (Component: React.ComponentType<any>) => (
  props: ComponentProps
) => {
  const context = props.context;

  if (
    !context ||
    !context.searchContext ||
    !context.searchContext.location ||
    !context.searchContext.location.name ||
    context.searchContext.location.type !== "hotel"
  ) {
    return null;
  }

  const inputs = {
    context: getBexApiContext(context),
    propertyId: String(context.searchContext.location.id)
  };

  return <Component inputs={inputs} />;
};
